import styled from 'styled-components';
import {colors} from 'styles/constants';

const MutedText = styled.span`
	color: ${colors.grey4};
`;

export default MutedText;
